import { CentrifugeContext } from '../Centrifuge.context'
import { useCentrifuge } from '../Centrifuge.hooks'

function CentrifugeProvider({ children, outboundUuid }) {
  const value = useCentrifuge({ outboundUuid })

  return <CentrifugeContext value={value}>{children}</CentrifugeContext>
}

export default CentrifugeProvider
